import React from 'react';
import FrameworkMappingSectionV3 from 'Components/forms/BaseDetectionForm/BaseDetectionFormMappingsSection/FrameworkMappingSectionV3';

const BaseDetectionFormMappingsSectionV3: React.FC<{ canEdit?: boolean }> = ({
  canEdit = true,
}) => {
  return <FrameworkMappingSectionV3 canEdit={canEdit} />;
};

export default React.memo(BaseDetectionFormMappingsSectionV3);
